export const DATE_WITH_TIME = 'M/D/YYYY, LT'
export const LOCALIZED = 'L'
export const LOCALIZED_LONG = 'LL'
export const ISO_EXTENDED = 'YYYY-MM-DD'
export const MESSAGE_TIME = 'LT'
export const PATIENT_MEASUREMENT_DATE = 'MMM DD, YYYY'
export const PROGRESS_DATE = `dddd, L @ ${MESSAGE_TIME}`
